/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Sign_IntroInputs */



/**
* | output |
* | --- |
* | "Black Chantry Productions asks playtesters to sign this nondisclosure agreement. Read it, then sign by typing your full name below." |
*
* @param {Nda_Sign_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_sign_intro = /** @type {((inputs?: Nda_Sign_IntroInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Sign_IntroInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Black Chantry Productions demande aux playtesteurs de signer cet accord de confidentialité. Lisez-le, puis signez en saisissant votre nom complet ci-dessous.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Black Chantry Productions pide a los playtesters firmar este acuerdo de confidencialidad. Léalo y firme escribiendo su nombre completo abajo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A Black Chantry Productions pede aos playtesters que assinem este acordo de confidencialidade. Leia-o e assine digitando seu nome completo abaixo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Black Chantry Productions chiede ai playtester di firmare questo accordo di riservatezza. Leggilo, poi firma digitando il tuo nome completo qui sotto.")
	return /** @type {LocalizedString} */ ("Black Chantry Productions asks playtesters to sign this nondisclosure agreement. Read it, then sign by typing your full name below.")
});